module.exports = __webpack_public_path__ + "static/media/viki1.d59c1dc6.jpg";